import type { Locale } from "@borderless/database/enums";
import z from "zod";

export const langs = [
  "en",
  "ru",
  "es",
  "fr",
  "pt",
  "ar",
  // "ja",
] as const;

export const LangSchema = z.enum(langs);

export const langsWithRTL = ["ar"];
export type Lang = (typeof langs)[number];

export const langNames = {
  en: "English",
  ja: "日本語",
  ru: "Русский",
  es: "Español",
  fr: "Français",
  pt: "Português",
  ar: "العربية",
} as const;

export const langCookieName = "lang";
export const langStoriesCookieName = "lang_stories";

export const langCookie = (lang: Lang) => {
  return {
    name: langCookieName,
    httpOnly: true,
    sameSite: "lax",
    path: "/",
    value: lang,
    maxAge: 60 * 60 * 24 * 365 * 100, // 100 years (effectively forever)
  } as const;
};

export const langStoriesCookie = (lang: Locale) => {
  return {
    name: langStoriesCookieName,
    httpOnly: true,
    sameSite: "lax",
    path: "/",
    value: lang,
    maxAge: 60 * 60 * 24 * 365 * 100, // 100 years (effectively forever)
  } as const;
};
